import { $, $$ } from '@3pc/dom';
import Bus from 'modules/event-bus';
import { Accordion } from '@3pc/accordion';

class Header {
  BREAKPOINT = 1199;

  constructor(props) {
    this.container = props.container;
    this.burger = props.burger;
    this.menu = props.menu;
    this.handlers = props.handlers;
    this.menuIsActive = false;
    this.subAccordionAlreadyActive = false;
    this.subAccordion = [];
  }

  initSubAccordion = () => {
    const handlers = $$(this.handlers, this.container);
    if (handlers.length) {
      handlers.forEach(handler => {
        const target = handler.parentElement.nextElementSibling;
        const accordion = new Accordion({
          target,
          targetInner: $('.navigation__main-sublist-inner', target),
          handler,
          easing: 'easeInOutQuart',
          duration: 300,
          initOpened: false,
          openClassName: 'is-open',
        });
        accordion.init();
        this.subAccordion.push(accordion);
      });
    }
  };

  showMenu = () => {
    this.menu.classList.add('is-active');
    this.burger.classList.add('is-open');
    this.burger.setAttribute('aria-expanded', 'true');
    $('body').classList.add('menu-active');
    $('html').classList.add('menu-active');
  };

  hideMenu = () => {
    this.menu.classList.remove('is-active');
    this.burger.classList.remove('is-open');
    this.burger.setAttribute('aria-expanded', 'false');
    $('body').classList.remove('menu-active');
    $('html').classList.remove('menu-active');
  };

  toggleMenu = () => {
    if (this.menuIsActive) {
      this.menuIsActive = false;
      this.hideMenu();
    } else {
      this.menuIsActive = true;
      this.showMenu();
    }
  };

  handleResize = () => {
    if (window.innerWidth > this.BREAKPOINT) {
      if (this.menuIsActive) {
        this.menuIsActive = false;
        this.hideMenu();
      }
    }

    if (window.innerWidth <= this.BREAKPOINT) {
      if (!this.subAccordionAlreadyActive) {
        this.initSubAccordion();
        this.subAccordionAlreadyActive = true;
      }
    } else if (window.innerWidth > this.BREAKPOINT) {
      if (this.subAccordionAlreadyActive) {
        this.subAccordion.length &&
          this.subAccordion.forEach(subAccordion => subAccordion.destroy());
        this.subAccordion = [];
        this.subAccordionAlreadyActive = false;
      }
    }
  };

  bindEvents = () => {
    this.burger.addEventListener('click', this.toggleMenu);
  };

  init = () => {
    Bus.subscribe('resize', 'Navigation', this.handleResize);
    this.bindEvents();

    if (window.innerWidth <= this.BREAKPOINT) {
      this.initSubAccordion();
      this.subAccordionAlreadyActive = true;
    }
  };
}

const header = $('.navigation');
if (header) {
  new Header({
    container: header,
    burger: $('.burger-menu', header),
    menu: $('.navigation__inner', header),
    handlers: '.navigation__main-handler',
  }).init();
}
